
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`An array of suggested locations for the text provided in decreasing order of relevance.`}</p>
    <p>{`While a maximum of 20 locations can be requested, the current implementation does not return more than 10 recommendations.`}</p>
    <p>{`This query accepts browser tokens that include the `}<inlineCode parentName="p">{`query:ontologies`}</inlineCode>{` scope.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;